import React from 'react';
import cx from 'classnames';
import './Section.scss';

const Section = (props) => {
  const { className, title, children } = props;
  return (
    <div className={cx('section', className)}>
      {title && <div className="section-title">{title}</div>}

      <div className="section-content">{children}</div>
    </div>
  );
};

export default Section;
